const KEY = 'badminton_session_v3';

export const saveSession = (state) => {
  try {
    const { history, redoStack, ...rest } = state;
    localStorage.setItem(KEY, JSON.stringify({
      ...rest,
      savedAt: Date.now(),
      histLen: history?.length ?? 0,
    }));
  } catch (e) {}
};

export const loadSession = () => {
  try {
    const raw = localStorage.getItem(KEY);
    if (!raw) return null;
    const data = JSON.parse(raw);
    const age = Date.now() - (data.savedAt || 0);
    if (age > 1000 * 60 * 60 * 12) { clearSession(); return null; }
    return data;
  } catch { return null; }
};

export const clearSession = () => {
  try { localStorage.removeItem(KEY); } catch {}
};

export const saveSettings = (settings) => {
  try { localStorage.setItem('badminton_settings_v1', JSON.stringify(settings)); } catch {}
};

export const loadSettings = () => {
  try {
    const raw = localStorage.getItem('badminton_settings_v1');
    return raw ? JSON.parse(raw) : null;
  } catch { return null; }
};